<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDCE48"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #000">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left>
        <span class="itemHeading"> Apiary List </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end pt-4>
      <v-flex xs12 sm4 md3 xl2 text-left>
        <v-autocomplete
          outlined
          dense
          clearable
          color="#000000"
          label="Search by username"
          v-model="userid"
          :items="users"
          item-color="#000000"
          item-text="username"
          item-value="_id"
          hide-details
        >
          <template v-slot:selection="{ item }">
            {{ item.username }}
          </template>
          <template v-slot:item="{ item }">
            <span class="text-left">
              {{ item.username }}
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 px-md-1>
        <v-menu
          ref="fromDatePicker"
          v-model="fromDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              clearable
              v-model="fromDate"
              label="From Date"
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fromDate"
            no-title
            @input="fromDatePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 pl-md-1>
        <v-menu
          ref="toDatePicker"
          v-model="toDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              clearable
              v-model="toDate"
              label="To Date"
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="toDate"
            no-title
            @input="toDatePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm4 md3 xl2 text-left pt-2 pt-sm-0 pl-sm-2 align-self-center>
        <v-form @submit.prevent="appSearch">
          <v-text-field
            class="searchBox"
            v-model="searchKey"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search by location"
            solo
            flat
            hide-details
            color="#FDCE48"
          ></v-text-field>
        </v-form>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start py-4>
      <v-flex xs12 lg12 xl6 pa-1 v-for="(item, i) in apiaries" :key="i">
        <ApiariesItem v-bind:storage="item" />
      </v-flex>
      <v-flex xs12 v-if="apiaries.length < 1">
        <span class="itemKey"> No data available </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex xs12>
        <v-pagination
          v-model="currentPage"
          :length="pages"
          :total-visible="7"
          color="#919191"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ApiariesItem from "./apiariesItem";
export default {
  components: {
    ApiariesItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      apiaries: [],
      users: [],
      pages: 0,
      count: 20,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      searchKey: this.$route.query.searchKey
        ? this.$route.query.searchKey
        : null,
      userid: this.$route.query.user,
      fromDate: this.$route.query.from,
      toDate: this.$route.query.to,
      fromDatePicker: false,
      toDatePicker: false,
    };
  },
  watch: {
    currentPage() {
      this.$router.push({
        path: "/Admin/Apiary",
        query: {
          page: this.currentPage,
          user: this.$route.query.user,
          from: this.$route.query.from,
          to: this.$route.query.to,
        },
      });
    },
    userid() {
      this.getData();
      this.$router.push({
        path: "/Admin/Apiary",
        query: {
          user: this.userid,
        },
      });
    },
    fromDate() {
      this.$router.push({
        path: "/Admin/Apiary",
        query: {
          page: this.currentPage,
          user: this.$route.query.user,
          from: this.fromDate,
          to: this.$route.query.to,
        },
      });
    },
    toDate() {
      this.$router.push({
        path: "/Admin/Apiary",
        query: {
          page: this.currentPage,
          user: this.$route.query.user,
          from: this.$route.query.from,
          to: this.toDate,
        },
      });
    },
  },
  beforeMount() {
    this.getData();
    this.getUsers();
  },
  methods: {
    appSearch() {
      if (!this.searchKey) this.searchKey = null;
      this.$router.push({
        path: "/Admin/Apiary",
        query: {
          user: this.$route.query.user,
          searchKey: this.searchKey,
        },
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/cluster/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          user: this.$route.query.user,
          keyword: this.searchKey,
          page: this.$route.query.page,
          count: this.count,
          createdfrom: this.$route.query.from,
          createdto: this.$route.query.to,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.apiaries = response.data.data;
            this.pages = response.data.pages;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getUsers() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/allUsers",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          role: "User",
          page: 0,
          count: 0,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.users = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>